import * as React from 'react';
import {AdaptivityProvider, AppRoot, ConfigProvider} from '@vkontakte/vkui';
import App from './App';
import {createRoot} from 'react-dom/client';
import {RouterProvider} from "@vkontakte/vk-mini-apps-router";
import {router} from "./routing/routing";
import {
    getTelegramPlatform,
    initTelegramWebApp,
    isTelegramWebAppAvailable
} from "./services/telegramWebApp";
import {initTelegramAnalytics} from "./services/analytics";
import "./css/index.css";

initTelegramWebApp();
initTelegramAnalytics();

const Root = () => {
    const isTelegramWebApp = isTelegramWebAppAvailable();
    const tgPlatform = getTelegramPlatform();
    const vkuiPlatform = tgPlatform === "ios" || tgPlatform === "macos" ? "ios" : "android";

    return (
        <ConfigProvider
            appearance={"light"}
            platform={isTelegramWebApp ? vkuiPlatform : undefined}
            isWebView={isTelegramWebApp}
            hasCustomPanelHeaderAfter={false}
        >
            <AdaptivityProvider>
                <AppRoot mode="full">
                    <RouterProvider router={router}>
                        <App/>
                    </RouterProvider>
                </AppRoot>
            </AdaptivityProvider>
        </ConfigProvider>
    );
};

const root = createRoot(document.getElementById("root"));
root.render(<Root/>);

if (process.env.NODE_ENV === "development") {
    import("./eruda").then(({default: eruda}) => {});
}
